import PropTypes from 'prop-types';
import { GetScope } from '../features/authentication/hooks/useToken';
/**
 * Checks if a feature flag is enabled.
 * @param {string} flag - The name of the feature flag.
 * @returns {boolean} - True if the feature flag is enabled, false otherwise.
 */
export const flagEnabled = (flag) =>
  ['1', 1].includes(process.env[`REACT_APP_FLAG_${flag?.toUpperCase()}`] ?? 0);

flagEnabled.propTypes = {
  flag: PropTypes.string.isRequired,
};

export const consoleLog = (label, data, debugOverride = false) => {
  if (!flagEnabled('debugging') && !debugOverride) return;
  console.log(`[${label}]`, data);
};

export const isAdmin = () => {
  const scope = GetScope();
  return scope == undefined || scope === null;
};
